export default __webpack_public_path__ + "static/media/iamsamarth-Logo-Final.4a21c8b4.svg";